module.exports = __webpack_public_path__ + "src/asset/svg/bookmark/v/start.svg?977a02265792ce00df1d5604249bce6e";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/bookmark/v/start.svg
// module id = 88
// module chunks = 0